import * as sentry from '../../src/utils/sentry'
import type { CommonDeps } from '../../../app-core/lib/base/CommonDeps'
import { Imag_getSharedImage } from '../Imag/Imag.getSharedImage'
import { User_get } from '../User/User.get'
import { Serv_client } from '../Serv/Serv.client'
import { DS_getData } from '../DS/DS.Data'
import { isOnline } from '../Serv/Serv.socketClient'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { defaultLanguage } from '../../../shared/i18n/i18n.no-deps'
import { Translations } from '../../../shared/i18n/Translations'
import { Trans } from 'react-i18next'
import { I18N_replaceNameSlug } from '../I18N/I18N.slugs'
import { pick } from 'lodash'

export function Base_commonDeps(): CommonDeps {
    const user = User_get()
    const { accessToken, customer } = DS_getData()
    const userLang = user?.language || defaultLanguage

    return {
        reportError: sentry.err,
        triggerSentryReplay: sentry.triggerSentryReplay,
        getImage: Imag_getSharedImage,
        language: userLang,
        locale: user?.locale || 'en-GB',
        token: accessToken,
        customerSlug: customer?.slug,
        httpClient: Serv_client,
        isOnline,
        createLogger: Logg_createLogger,
        i18n: Translations.t,
        Trans,
        TFixed: Translations.fixed,
        I18N_replaceNameSlug,
        user: pick(user, 'id', 'name', 'email', 'nickname', 'privs', 'zapticStaff'),
    }
}
